module.exports = __webpack_public_path__ + "img/inspiring_background_mobile.480858d.jpg";